// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3ADX5","notes":"Notes_notes__3GyNg"};